<template>
  <div class="c-app noticeheight">
    <app-sidebar />
    <div class="c-wrapper wrapper-content" id="body">
      <!-- <app-headernew v-if="isLocal"></app-headernew> -->
      <app-header></app-header>

      <div class="c-body">
        <router-view></router-view>
      </div>
      <app-footer />
    </div>
  </div>
</template>

<script>
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
// import HeaderSecond from "../components/HeaderSecond";

export default {
  name: "TheContainer",
  components: {
    // "app-headernew": HeaderSecond,
    "app-header": Header,
    "app-sidebar": Sidebar,
    "app-footer": Footer
  },
  
  data() {
    return {
      isLocal: window.location.href.includes("juhilocal")
    };
  },
  
};
</script>
<style lang="scss">
  @import "../assets/css/custom.scss";
</style>

